import { useEffect, useState } from "react";
import { ApiError } from "../api";
import { useAuth } from "../auth";
import { Logo, Wordmark } from "../components/icons";
import { Button, Notice, TextField } from "../components/ui";

export default function Login() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState<"login" | "register">("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [discipline, setDiscipline] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  // Sign-up is off unless the server says otherwise (EVOLOG_OPEN_REGISTRATION).
  const [registration, setRegistration] = useState(false);

  useEffect(() => {
    fetch("/healthz")
      .then((response) => response.json())
      .then((health) => setRegistration(health.registration === true))
      .catch(() => setRegistration(false));
  }, []);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (mode === "login") {
        await login(username, password);
      } else {
        await register({ username, password, email, display_name: displayName, discipline });
      }
    } catch (cause) {
      setError(
        cause instanceof ApiError
          ? cause.status === 401
            ? "Wrong username or password."
            : cause.detail
          : "Cannot reach the server.",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        background:
          "radial-gradient(1100px 600px at 50% -10%, rgba(53,184,198,.10), transparent 65%), var(--app-bg)",
        padding: 24,
      }}
    >
      <div style={{ width: 380, maxWidth: "100%", display: "flex", flexDirection: "column", gap: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Logo size={38} />
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Wordmark size={22} weight={700} />
            {/* Kalimat yang sama dengan yang tertulis di logonya. Aplikasi yang
                menyebut dirinya dengan kalimat lain daripada lambangnya adalah
                dua nama untuk satu barang. */}
            <span style={{ font: "400 11px var(--font-mono)", color: "var(--ink-5)" }}>
              Evaluasi Formasi &amp; Well Log Modeling
            </span>
          </div>
        </div>

        <form
          onSubmit={submit}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 14,
            padding: 20,
            background: "var(--panel)",
            border: "1px solid var(--border-control)",
            borderRadius: "var(--radius-panel)",
            boxShadow: "var(--shadow-panel)",
          }}
        >
          {registration && (
            <div style={{ display: "flex", gap: 4 }}>
              {(["login", "register"] as const).map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => {
                    setMode(option);
                    setError(null);
                  }}
                  style={{
                    flex: 1,
                    padding: "7px 0",
                    border: "none",
                    borderBottom: `2px solid ${mode === option ? "var(--accent)" : "transparent"}`,
                    background: "transparent",
                    color: mode === option ? "var(--ink)" : "var(--ink-5)",
                    font: `${mode === option ? 600 : 500} 11.5px var(--font-sans)`,
                    cursor: "pointer",
                  }}
                >
                  {option === "login" ? "Sign in" : "Register"}
                </button>
              ))}
            </div>
          )}

          <TextField label="Username" value={username} onChange={setUsername} autoFocus />
          {mode === "register" && (
            <>
              <TextField label="Full name" value={displayName} onChange={setDisplayName} />
              <TextField label="Email" type="email" value={email} onChange={setEmail} />
              <TextField
                label="Discipline"
                value={discipline}
                onChange={setDiscipline}
                placeholder="Petrophysicist, Geologist, …"
              />
            </>
          )}
          <TextField label="Password" type="password" value={password} onChange={setPassword} />

          {error && <Notice tone="error">{error}</Notice>}

          <Button type="submit" variant="primary" full busy={busy} style={{ height: 36 }}>
            {mode === "login" ? "Sign in" : "Create account"}
          </Button>
        </form>

      </div>
    </div>
  );
}
